import { render, staticRenderFns } from "./moveDetailsApply.vue?vue&type=template&id=0e542dde&scoped=true&"
import script from "./moveDetailsApply.vue?vue&type=script&lang=js&"
export * from "./moveDetailsApply.vue?vue&type=script&lang=js&"
import style0 from "./moveDetailsApply.vue?vue&type=style&index=0&id=0e542dde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e542dde",
  null
  
)

export default component.exports